// imports
import React from 'react';
import Select from 'react-select';
import { Icon } from 'react-icons-kit';
import SyntaxHighlighter from 'react-syntax-highlighter';

import Heading from 'reusecore/src/elements/Heading';
import Tab, { Panel } from 'common/src/components/Tabs';
import Container from 'common/src/components/UI/Container';

import data from './data';
import SectionWrapper, { ContentWrapper } from './codeSnippetPanel.style';
import { githubGist } from 'react-syntax-highlighter/dist/esm/styles/hljs';

// globals
const { codeSnippets } = data;

// exports - react class
export default class CodeSnippetPanel extends React.Component {
  constructor(props) {
    super(props);

    this.dropdownInitiated = false;
    this.state = {
      selectedOption: {
        value: 0,
        label: 'Unity / .NET',
        icon: codeSnippets['Unity / .NET'].icon
      }
    };
  }

  // react lifecycle
  render() {
    const { selectedOption } = this.state;
    const platforms = Object.keys(codeSnippets);

    return (
      <SectionWrapper id='snippets_integration'>
        <Container>
          <Heading
            className='titleHeading'
            fontSize={['20px', '24px', '36px', '36px']}
            content='Designed by Game Developers for Game Developers'
          />
          <Heading
            className='titleHeading'
            content={'Add chat in minutes!'}
            fontSize={['14px', '14px', '16px', '18px']}
          />
          <Select
            value={selectedOption}
            onChange={this.handleChange}
            className='snippets_integration_dropdown'
            options={this.renderDropdownOptions(platforms)}
            components={{ SingleValue: this.renderDropdownIcon }}
          />
          <Tab active={0} className='snippets_integration_tab' callback={this.handleTabCallback}>
            {this.renderTabs(platforms)}
          </Tab>
          <a className='docs_link' href='https://docs.fizz.io' target='_blank'>{'Full API reference →'}</a>
        </Container>
      </SectionWrapper>
    );
  }

  // render helpers
  renderTabs(platforms) {
    return platforms.map(title => {
      const currSnippet = codeSnippets[title];
      const { code, icon, language } = currSnippet;

      return (
        <Panel title={title} key={`tab_key${title}`} icon={icon}>
          <ContentWrapper>
            <div className='content'>
              <SyntaxHighlighter style={githubGist} language={language} showLineNumbers={true}>
                {code}
              </SyntaxHighlighter>
            </div>
          </ContentWrapper>
        </Panel>
      );
    });
  }

  renderDropdownIcon = ({ data }) => (
    <div className='input-select'>
      <div className='input-select__single-value'>
        {data.icon && <Icon icon={data.icon} id={data.icon.id} />}
        <span>{data.label}</span>
      </div>
    </div>
  );

  renderDropdownOptions(platforms) {
    return platforms.map((title, idx) => {
      const currSnippet = codeSnippets[title];
      return { label: title, icon: currSnippet.icon, value: idx };
    });
  }

  // event handlers
  handleTabCallback = (selectedIdx) => {
    if (this.dropdownInitiated) {
      this.dropdownInitiated = false;
      return;
    }

    const platforms = Object.keys(codeSnippets);
    const title = platforms[selectedIdx];

    const currSnippet = codeSnippets[title];
    this.handleChange({ label: title, icon: currSnippet.icon, value: selectedIdx });
  }

  handleChange = (selectedOption, selectionParams = null) => {
    this.setState({ selectedOption });

    if (selectionParams) {
      this.dropdownInitiated = true;
      document.querySelectorAll('.snippets_integration_tab .tab_menu li')[selectedOption.value].click();
    }
  }
}